import { useState, useEffect } from "react";

const PULSE_DURATION_MS = 2500;

/** Marker pulse animation: the active space id pulses for 2.5s, then stops. */
export function useMarkerPulse(activeSpaceId?: string | null): string | null {
  const [pulsingId, setPulsingId] = useState<string | null>(null);

  useEffect(() => {
    if (!activeSpaceId) return;
    setPulsingId(activeSpaceId);
    const timer = setTimeout(() => setPulsingId(null), PULSE_DURATION_MS);
    return () => clearTimeout(timer);
  }, [activeSpaceId]);

  return pulsingId;
}
